import { useEffect, useState } from "react";
import { Col, FormControl, Row } from "react-bootstrap";
import Api from "../../utils/api";

const ProfilesScreen = () => {

    const [profiles, setProfiles] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        fetchData();
    }, []);


    const fetchData = async () => {
        try {


            const data1 = await Api.get('/profiles')
            setProfiles(data1)
        } catch (error) {
            console.error('Error al obtener los datos:', error);
        }
    };


    const ProfileItem = ({ item }) => {
        return (
            <Col md={4}>
                <div className="source-item">
                    <Row className="justify-content-between">
                        <Col>
                            <a className="text-decoration-none" href={`/profiles/${item.id}`}>
                                <span className="small text-success">{item.id}</span>
                                {' '}
                                <span className="fs-5"> {item.name}</span>
                            </a>
                        </Col>
                    </Row>
                </div>
            </Col>
        );
    }



    return (
        <>
            <Row className="mt-5 justify-content-between">
                <Col lg={4} md={6} sm={12}>
                    <h3>Lista de Perfiles</h3>
                </Col>
                <Col lg={4} md={6} sm={12}>
                    <FormControl className="form-control search-input" type="search" placeholder="Search" autoComplete="off" value={search} onChange={(e) => setSearch(e.target.value.toLowerCase())} />
                </Col>
            </Row>


            <Row className="gx-4 gy-3 mt-3">
                {profiles.map((item, index) => (
                    <ProfileItem item={item} key={index} />
                ))}
            </Row>
        </>
    );
}

export default ProfilesScreen;